/**
 * 评论相关接口
 */
import request from './request'

/**
 * 获取评论列表
 * @param {object} params - { pageNum, pageSize, newsId }
 */
export function getCommentList(params) {
  return request.post('/api/comment/getCommentList', params)
}

/**
 * 发表评论
 * @param {object} params - { content, newsId }
 */
export function addComment(params) {
  return request.post('/api/member/comment/add', params)
}

/**
 * 回复评论
 * @param {object} params - { parentId, content }
 */
export function replyComment(params) {
  return request.post('/api/member/comment/reply', params)
}

/**
 * 评论点赞/踩
 * @param {object} params - { commentId, actionType } 1 顶 2 取消顶 3 踩 4 取消踩
 */
export function voteComment(params) {
  return request.post('/api/comment/voteComment', params)
}
